module.exports = __webpack_public_path__ + "static/open-graph-default-918991784f321fdf75a2951eacba1a0b.png";